import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { IinfoIconSettings, breedingPicPath, currencyImgPath, eInfoIconType, elementPicPath, genderPicPath } from './info-icon.interface';
import { eElementType } from 'app/services/kryptomons/kryptomons.interface';
import { formatNum } from 'app/common/utils/number.util';

@Component({
  selector: 'info-icon',
  templateUrl: './info-icon.component.html',
  styleUrls: ['./info-icon.component.scss'],
})
export class InfoIconComponent implements OnInit, OnChanges {

  @Input() settings: IinfoIconSettings = {
    type: eInfoIconType.element,
    id: eElementType.Fire,
  }
  @Input() imgPath: string;
  @Input() size: | 'xs' | 'md' | 'l' | 'xl' = 'xs'
  _currencyValue: string;

  ngOnInit(): void {
    this.ngOnChanges();
  }

  ngOnChanges() {
    if (this.settings) {
      switch (this.settings.type) {
        case eInfoIconType.element:
          this.imgPath = elementPicPath[this.settings.id]
          break;
        case eInfoIconType.breeding:
          this.imgPath = breedingPicPath;
          break;
        case eInfoIconType.gender:
          this.imgPath = genderPicPath[this.settings.id];
          break;
        case eInfoIconType.currency:
          this.imgPath = currencyImgPath()[this.settings.currencyType]
          break;
        case eInfoIconType.syntetic:
          this.imgPath = './assets/img/Icon/Starter.png';
          break;
        default:
          break;
      }
      if (this.settings.type == eInfoIconType.currency) this._currencyValue = formatNum(parseFloat(this.settings.label + ''));

    }
  }
}
